import React, { useEffect, useRef } from 'react';
import { Box } from '@mui/material';
import ChatMessage from './ChatMessage';
import innerStyles from './index.module.scss';

const styles = { ...innerStyles };

const ChatMessageBox = ({ messages, instructions }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [messages]);

  return (
    <>
      <Box ref={containerRef} className={styles.chatMessageBox}>
        {messages.length === 0 && (
          <div className={styles.helpMessage}>{instructions}</div>
        )}
        {messages.map((message) => (
          <ChatMessage message={message} />
        ))}
      </Box>
    </>
  );
};

export default ChatMessageBox;
